import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=c7d875e8&"
import script from "./DrawerMenu.vue?vue&type=script&lang=ts&"
export * from "./DrawerMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports